import axios from "axios";
import { userModule } from "@/store/modules/user";
import router from "@/router";
import ErrorAlert from "@/utility/ErrorAlert";

// const API_URL = "http://10.10.187.6/test-rme/public/api/v1";
// const API_URL = 'http://10.10.187.6/rme/public/api/v1'
const API_URL = process.env.VUE_APP_API_BRIDGING_VCLAIM;
// const API_URL = 'http://192.168.201.241/api-bpjs/public/api';
// const API_URL = 'http://10.10.187.4:84/api';

const instance = axios.create({
  baseURL: API_URL,
  timeout: 20000,
  params: {} // do not remove this, its added to add params later in the config
});

// Add a request interceptor
instance.interceptors.request.use(
  function (config) {
    // const token = userModule.token;
    // // console.log("token", token);
    // if (token) {
    //   config.headers.common["Authorization"] = "Bearer " + token;
    //   config.headers.common["Access-Control-Allow-Origin"] = "*";
    // } else {
    //   // Use application/x-www-form-urlencoded for login
    //   config.headers.common["Content-Type"] =
    //     "application/x-www-form-urlencoded";
    // }

    return config;
  },
  function (error) {
    // Do something with request error
    // alert("login err")

    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  response => response,
  error => {
    // let dt = error.response
    // console.log('err login ',error);
    // alert("login err")
    if (error.response?.status === 401) {
      userModule.logout();
      router.push({
        path: "/login",
        params: { message: "Autentikasi User gagal atau sesi Anda telah habis" }
      });
    } else {
      ErrorAlert.showErrorAlert(error);
    }
    // else if (dt.status == 422) {

    //   let message = "";

    //   message = join(
    //     values(
    //       mapValues(error.response.data.errors, function (val) {
    //         return join(val, "; ");
    //       })
    //     ),
    //     "; "
    //   );
    //   dt = { status: 0, err: "ERR 422 : " + error.response.data.message + " (" + message + ")" }
    //   // dt = { status: 0, err: "ERR 422 : " + error.response.data.message }
    //   appModule.sendErrorAlert(dt["err"]);
    // } else {
    //   dt = { data: dt, status: dt['status'], err: "ERR " + error.response.status + " : " + error.response.data.message }
    //   appModule.sendErrorAlert(dt["err"]);
    //   // alert(dt["err"]);
    // }

    return Promise.reject(error);
  }
);

export default {
  getAPI() {
    const url = `${API_URL}`;
    return url;
  },
  getData(endpoint, data = null) {
    let url = `${API_URL}`;
    url += endpoint;

    return instance.get(url, data);
  },
  getDataParam(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  postData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.post(url, data);
  },
  putData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.put(url, data);
  },
  deleteData(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    const config = {
      data
    };

    return instance.delete(url, config);
  },
  login(endpoint, data) {
    let url = `${API_URL}`;
    url += endpoint;
    return instance.get(url, data);
  },
  // deleteDataParam(endpoint, data) {
  //   let url = `${API_URL}`;
  //   url += endpoint;
  //   return instance.delete(url, data);
  // },
  apiUrl: API_URL
};
